import React from 'react';

const RunbookSlack = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.969727"
      y="5.24219"
      width="14.0451"
      height="14.091"
      rx="6"
      transform="rotate(-19.6945 0.969727 5.24219)"
      stroke="currentColor"
    />
    <path
      d="M10.4145 4.93301C10.3209 4.6732 10.0344 4.53844 9.77461 4.63201C9.5148 4.72558 9.38004 5.01205 9.47361 5.27186L10.4145 4.93301ZM12.2147 12.8827C12.3082 13.1425 12.5947 13.2773 12.8545 13.1837C13.1143 13.0901 13.2491 12.8037 13.1555 12.5438L12.2147 12.8827ZM9.47361 5.27186L12.2147 12.8827L13.1555 12.5438L10.4145 4.93301L9.47361 5.27186Z"
      fill="currentColor"
    />
    <path
      d="M7.61563 5.95645C7.52206 5.69664 7.23559 5.56188 6.97578 5.65545C6.71598 5.74902 6.58121 6.03549 6.67478 6.29529L7.61563 5.95645ZM9.41585 13.9061C9.50942 14.1659 9.79588 14.3007 10.0557 14.2071C10.3155 14.1136 10.4503 13.8271 10.3567 13.5673L9.41585 13.9061ZM6.67478 6.29529L9.41585 13.9061L10.3567 13.5673L7.61563 5.95645L6.67478 6.29529Z"
      fill="currentColor"
    />
    <path
      d="M5.4246 8.94954C5.16543 9.04485 5.03259 9.33221 5.12789 9.59139C5.22319 9.85056 5.51056 9.9834 5.76973 9.8881L5.4246 8.94954ZM13.3621 7.09623C13.6212 7.00093 13.7541 6.71356 13.6588 6.45439C13.5635 6.19521 13.2761 6.06237 13.0169 6.15768L13.3621 7.09623ZM5.76973 9.8881L13.3621 7.09623L13.0169 6.15768L5.4246 8.94954L5.76973 9.8881Z"
      fill="currentColor"
    />
    <path
      d="M6.46806 11.7406C6.20889 11.8359 6.07604 12.1232 6.17135 12.3824C6.26665 12.6416 6.55401 12.7744 6.81319 12.6791L6.46806 11.7406ZM14.4055 9.88725C14.6647 9.79194 14.7976 9.50458 14.7022 9.24541C14.6069 8.98623 14.3196 8.85339 14.0604 8.94869L14.4055 9.88725ZM6.81319 12.6791L14.4055 9.88725L14.0604 8.94869L6.46806 11.7406L6.81319 12.6791Z"
      fill="currentColor"
    />
  </svg>
);

export default RunbookSlack;
